import { InputText } from './InputText'
export default InputText;

export { skeletonInputTextComLabel } from './input-text-skeleton';
export { InputText, InputTextProps as TextInputProps } from './InputText';
